export default __webpack_public_path__ + "static/88a061c2-3303-401d-85e9-619b5ea5f5af-bb2b3abf35c5242e5e6f13db9d20d8b6.eot";